/**
 * components/organisms/Dashboard/MassActions.jsx
 */
import useDataTableUtils from 'src/use-cases/dashboard/useDataTableUtils';
import { InvoiceDto } from 'src/generated/services/TFinancialApi';
import { TableActionType, useTableContext, useTableDispatch } from 'src/presentations/components/molecules/table/State';
import Button from 'src/presentations/components/atom/button';
import { ModalInfo, ModalConfirm } from 'src/presentations/components/molecules/modal';
import { MassActionType } from './types';

const MassActions = () => {
  const { selectedItems: items } = useTableContext();
  /**
   * Setup data table
   */
  const {
    actionType,
    isActionLoading,
    isShowActionResult,
    isShowActionConfirm,
    onSubmitMassAction,
    onClickMassAction,
    setIsShowActionConfirm,
    setIsShowActionResult,
  } = useDataTableUtils();

  /**
   * onClickApprove
   */
  const onClickApprove = () => {
    onClickMassAction(MassActionType.TO_APPROVE);
  };

  /**
   * onClickReject
   */
  const onClickReject = () => {
    onClickMassAction(MassActionType.TO_REJECT);
  };

  /**
   * onClickReject
   */
  const onAcceptConfirm = () => {
    const newItems = [...items];
    onSubmitMassAction(newItems);
  };

  const { dispatch } = useTableDispatch();

  const onCloseResult = () => {
    dispatch({ type: TableActionType.CLEAR_SELECTED_ITEMS });
    setIsShowActionResult(false);
  };

  if (items.length > 0) {
    const toApproveItems = items?.filter((item: InvoiceDto) => item?.status === MassActionType.TO_APPROVE);
    const toRejectItems = items?.filter((item: InvoiceDto) => item?.status === MassActionType.TO_REJECT);

    return (
      <>
        <div className='relative flex items-center gap-16'>
          {toApproveItems.length === 1 && (
            <Button variant='primary' onClick={onClickApprove}>
              Approve
            </Button>
          )}
          {toRejectItems.length > 0 && toRejectItems.length === items.length && (
            <Button variant='danger' onClick={onClickReject}>
              Reject
            </Button>
          )}
        </div>

        <ModalConfirm
          open={isShowActionConfirm}
          title='Confirmation'
          isLoading={isActionLoading}
          onAccept={onAcceptConfirm}
          onCancel={() => setIsShowActionConfirm(false)}
        >
          <>
            {actionType === MassActionType.TO_REJECT && <p>Are you sure want to reject these {toRejectItems.length} invoices?</p>}
            {actionType === MassActionType.TO_APPROVE && (
              <>
                <p>Are you sure you want to approve this invoice?</p>
                <div className='mt-20 p-24 border border-neutral-20 rounded-8 grid gap-x-24 grid-cols-2 grid-rows-2'>
                  <div className='text-14 text-blue_grey-30'>Total Amount to be Paid</div>
                  <div className='text-16 font-bold text-right'>USD 300,000.00</div>
                  <div className='text-12 text-blue_grey-30'>Before Tax</div>
                  <div className='text-12 font-bold text-right'>USD 30,000.00</div>
                </div>
              </>
            )}
          </>
        </ModalConfirm>

        <ModalInfo open={isShowActionResult} title='Success!' onClose={onCloseResult}>
          <p>The selected invoices have been processed successfully.</p>
        </ModalInfo>
      </>
    );
  }
  return null;
};

export default MassActions;
